module.exports = __webpack_public_path__ + "static/media/assiette.55f120f4.png";